// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraComboBox } from './TerceraComboBox';
export class TerceraWidthComboBox extends TerceraComboBox {
    get maxWidth() {
        return this.width;
    }
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraWidthComboBox;
    }
    oninit() {
        super.oninit();
        this.initComboBoxSettings();
    }
    onSelectedItemChanged(newValue, oldValue) {
        super.onSelectedItemChanged(newValue, oldValue);
        if (isNullOrUndefined(newValue)) {
            return;
        }
        const icon = newValue.svgImage;
        if (!isNullOrUndefined(icon))
            this.set({ icon });
    }
    initComboBoxSettings() {
        void this.set({
            listWidth: 100,
            useSVGView: true,
            imagewidth: 52,
            updateComboBoxClass: 'upClassWidthComboBox'
        });
    }
}
TerceraComboBox.extendWith(TerceraWidthComboBox, {
    data: () => {
        return {
            showLastValue: true
        };
    }
});
